import React from "react";
import { useContent } from "@/context/ContentContext";
import { useLang } from "@/context/LanguageContext";
import { ext } from "@/lib/ext";

const FAQ = () => {
  const content = useContent();
  const { lang } = useLang();
  const e = ext[lang];
  const faq = content?.faq || [];
  return (
    <main className="mx-auto max-w-2xl px-4 py-16 sm:px-6" data-testid="faq-page">
      <h1 className="text-3xl uc font-semibold sm:text-4xl">{e.faq}</h1>
      <div className="mt-8 divide-y divide-border border-y border-border">
        {faq.map((f, i) => (
          <div key={i} className="py-5" data-testid={`faq-item-${i}`}>
            <div className="font-mono text-sm uppercase tracking-widest">{lang === "ro" ? f.q_ro : f.q_en}</div>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{lang === "ro" ? f.a_ro : f.a_en}</p>
          </div>
        ))}
      </div>
    </main>
  );
};

export default FAQ;
